import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'
import http from 'API/http'

class LeaseInfo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      leaseInfo: null,
      error: false,
      loading: true
    }
  }

  componentDidMount () {
    this.getLeaseInfo(this.props.id)
  }

  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true})
    this.getLeaseInfo(props.id)
  }

  async getLeaseInfo (id) {
    var [err, res] = await http.get('2.4/tech/access/' + id + '/link/leaseinfo')
    if (err) return this.setState({error: true, cause: res.cause, loading: false})
    this.setState({leaseInfo: res.data, loading: false})
  }

  reload () {
    this.setState({loading: true})
    this.getLeaseInfo(this.props.id)
  }

  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='Lease Info' icon='info' buttons={[{ icon: (this.state.loading ? 'fa-refresh fa-spin' : 'fa-refresh'), event: () => this.reload(), disabled: this.state.loading}]}>
        {this.state.leaseInfo &&
          <pre className='no-overflow mt-10 no-padding'>
            <FlowTable noClass data={this.state.leaseInfo.map(lease => [
              lease.lease,
              lease.mac,
              lease.serviceType,
              lease.start,
              lease.end
            ])}>
              <tr>
                <th>Lease</th>
                <th>Mac</th>
                <th>Service Type</th>
                <th>Start</th>
                <th>End</th>
              </tr>
            </FlowTable>
          </pre>
        }
        {this.state.error &&
          <pre className='table-pre mt-10'>
            <div className='error-wrapper'>
              <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching Lease Info {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
            </div>
          </pre>
        }
      </StaticBox>
    )
  }
}
export default LeaseInfo



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/troubleshooting/LeaseInfo.js